export enum EnumPermission {
    User_Read,
    User_Write,
    SuiviCA_Read,
    SuiviConso_Read,
    SuiviFacturation_Read,
    Profil_Read,
    FormulaireModele_Write,
    EtatStock_Read,
    PMNAdministraton_ReadWrite,
    PMNDemande_ReadWrite,
    PMNDemandeListeClient_ReadWrite,
    File_Write,
    Evenement_Write,
    FormulaireReponse_ReadWrite = 14,
    FormulaireReponseAdministration_ReadWrite,
    SuiviDemandesReeditionFacturation_ReadWrite,
    Inventaire_Write,
    InventaireResultat_Read,
    Commande_Write,
    CommandeResultat_Read,
    FicheImplantation_ReadWrite,
    FicheImplantationAdministration_ReadWrite,
    AdministrationProduits = 23,
    Inventaire_Delete,
    RotationProduits_Write,
    SuiviRecueil_Read,
    SuiviKits,
    File_Share
}
